import CatalogFlowePage from '../components/elements/CatalogFlowePage';
//кнопка вверх
$(document).ready(function () {
  $(window).scroll(function () {
    if ($(document).scrollTop() > 10) {
      $('#scroll').css('display', 'block');
    }
    else {
      $('#scroll').css('display', 'none');
    }
  });
  $('#toTop').click(function () {
    $('html, body').animate({scrollTop: $('html').offset().top}, 'slow');
    return false;
  });
});

if (document.getElementsByClassName('image-text-link').length > 0) {
  $('.image-text-link').magnificPopup({type: 'image'});
}

if (document.getElementById('catalog-flower-page')) {
    new Vue({
        el: '#catalog-flower-page',
        components: {
            CatalogFlowePage
        },
    });
}



// WEBPACK FOOTER //
// ./resources/js/snippets/common.js